import { useRouteMatch } from 'react-router-dom'

import { DOC_PATH } from 'paths'
import { UserRole } from 'types'
import { useUserRole } from './useUserRole'
import { useArticleMeta } from './useArticleMeta'

export const useGuestVisitingDoc = () => {
  const role = useUserRole()
  const docRouteMatch = useRouteMatch<any>(DOC_PATH)
  const articleIdInUrl = docRouteMatch?.params.slug.split('-').pop() ?? null
  const currentArticleMeta = useArticleMeta(articleIdInUrl)

  return role === UserRole.UNAUTHED && currentArticleMeta != null && !currentArticleMeta?.made_public
}
